module.exports = __webpack_public_path__ + "img/clock.2d542753.svg";